import { render, staticRenderFns } from "./CommonWarpper.vue?vue&type=template&id=1c8c1cc6&scoped=true"
import script from "./CommonWarpper.vue?vue&type=script&lang=js"
export * from "./CommonWarpper.vue?vue&type=script&lang=js"
import style0 from "./CommonWarpper.vue?vue&type=style&index=0&id=1c8c1cc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8c1cc6",
  null
  
)

export default component.exports